import React, { useMemo, useState } from 'react';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import { alpha } from '@mui/material';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

const findByNameAndValue = (myArr, providedName, providedValue) => {
  return myArr?.find(
    ({ fieldName, value }) => providedName === fieldName && providedValue === value
  );
};
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: alpha(get(theme.palette.primary, 'main'), 0.4)
  }
}));

const Sorters = ({
  configuration = [],
  isMobile,
  disabled = false,
  handleSorting = () => {},
  sortBy,
  sortDirection,
  sortIcon = 'sort'
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const currentSortIcon = useMemo(() => {
    const selectedSortField = findByNameAndValue(configuration, sortBy, sortDirection);
    return {
      iconName: `${selectedSortField?.iconName || 'sort'}`,
      hoveringText: Localize.get(selectedSortField?.translationKey || 'App.sortDefault')
    };
  }, [sortBy, sortDirection, configuration]);

  return (
    <>
      <Tooltip title={currentSortIcon.hoveringText} arrow>
        <StyledIconButton
          onClick={handleMenuClick}
          disabled={disabled}
          data-testid='sortersContainer'
        >
          <Icon>{sortIcon}</Icon>
        </StyledIconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {configuration
          .filter((srt) => srt.visible)
          .map((sorter) => (
            <MenuItem
              key={`${sorter.fieldName}-${sorter.value}`}
              selected={sortBy === sorter.fieldName && sortDirection === sorter.value}
              disabled={sorter?.disabled}
              name={sorter.fieldName}
              value={sorter.value}
              onClick={() => {
                handleSorting(sorter.fieldName, sorter.value, sorter.iconName);
                handleMenuClose();
              }}
            >
              <Tooltip title={Localize.get(sorter?.translationKey)} placement='right' arrow>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {!isMobile && <Icon>{sorter.iconName}</Icon>}
                  {isMobile && Localize.get(sorter?.translationKey)}
                </div>
              </Tooltip>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default Sorters;
